import { useNavigate } from 'react-router-dom'

/**
 * Правила игры — веб-версия _RULES_TEXT (app/handlers/navigation.py), дословно.
 */
export default function Rules() {
  const navigate = useNavigate()

  return (
    <>
      <h1>📜 Правила игры</h1>

      <div className="card">
        <b>Опыт и уровни</b>
        <p style={{ margin: '8px 0' }}>
          🌱 Новичок — 📚 Ученик (100 XP) — 🧠 Знаток (500 XP) — 🏆 Мастер (1500 XP)
        </p>
        <p className="small muted" style={{ margin: 0 }}>
          За решённую задачу: 15 / 30 / 60 XP (лёгкая / средняя / сложная), 20 XP —
          если сложность у задачи не указана
          <br />
          +50% XP — комбо ×3 (три верных ответа с первой попытки подряд)
          <br />
          −5 XP — за каждую неверную попытку
        </p>
      </div>

      <div className="card">
        <b>Комбо</b>
        <p className="small muted" style={{ margin: '8px 0 0' }}>
          ×N Комбо — верные ответы с первой попытки подряд. Сбрасывается ошибкой,
          а не просьбой о помощи.
        </p>
      </div>

      <div className="card">
        <b>Значки 🏅</b>
        <p className="small muted" style={{ margin: '8px 0 0' }}>
          За количество верно решённых задач и за решения с первой попытки без
          помощи — все значки и условия в «🏆 Достижения».
        </p>
      </div>

      <div className="row-wrap" style={{ marginTop: 16 }}>
        <button className="btn" onClick={() => navigate('/achievements?from=rules')}>🏆 Достижения</button>
        <button className="btn" onClick={() => navigate('/')}>🏠 Главная</button>
      </div>
    </>
  )
}
